import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import { Switch } from '@main/complykit';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { DrawerProperty } from '@main/ui';

import { useUpdateOrganizationHandler } from './use-update-org-handler';

export const PoliciesModuleSwitch = ({ orgId }: { orgId: string }) => {
  const { data } = useGetOrganizationQuery({ orgId });
  const organization = data?.organizations_by_pk;
  const [updateOrganization, { isLoading }] = useUpdateOrganizationMutation();
  const updateOrgHanlder = useUpdateOrganizationHandler(orgId);

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label
        id="policies-module-label"
        htmlFor="policies-module"
        icon={ShieldCheckIcon}
      >
        Policies module
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} display="flex" alignItems="center">
        <Switch
          id="policies-module"
          aria-labelledby="policies-module-label"
          isSelected={organization.is_policies_module_enabled}
          isPending={isLoading}
          onChange={async () => {
            updateOrgHanlder(
              updateOrganization({
                organization_id: orgId,
                updatePayload: {
                  is_policies_module_enabled: !organization.is_policies_module_enabled,
                  ...(organization.is_policies_module_enabled && {
                    is_policy_acknowledgements_enabled: false,
                  }),
                },
              }),
            );
          }}
        />
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
